import React, { useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import WebPasscode from 'common/passcode/WebPasscode.web';
import { usePasscodeVerifier } from 'hooks/usePasscodeVerifier';
import Modal from 'utils/packages/Modal';
const strings = {
    title: 'Enter Your Pin Code',
    passcodeFailed: 'Your code is wrong!',
};
const PasscodeModalContent = ({ onSuccess }) => {
    const [passcodeVerifier] = usePasscodeVerifier();
    const [passcode, setPasscode] = useState('');
    const [failed, setFailed] = useState(false);
    const onFilled = useCallback(async (passcodeEntered) => {
        try {
            if (await passcodeVerifier(passcodeEntered, true)) {
                Modal.hide(undefined, { top: true });
                onSuccess(passcodeEntered);
            }
            else {
                setFailed(true);
                setPasscode('');
            }
        }
        catch {
            setPasscode('');
        }
    }, [onSuccess, passcodeVerifier]);
    useEffect(() => {
        if (passcode.length === 4) {
            onFilled(passcode);
        }
    }, [passcode, onFilled]);
    return (<View>
      <WebPasscode value={passcode} setValue={setPasscode} failed={failed} errorMessage={strings.passcodeFailed} onCard/>
    </View>);
};
/**
 * Web version of PasscodeModal. Native mounts PasscodeModal in Navigator and
 * shows a pin pad sheet; web has no mounted instance, so `show` opens the
 * PIN entry in the web Modal instead. Closing the modal counts as a failure.
 */
const PasscodeModal = () => null;
PasscodeModal.show = ({ title, onSuccess, onFailure }) => {
    Modal.show(<PasscodeModalContent onSuccess={onSuccess}/>, {
        top: true,
        title: title ?? strings.title,
        onPressClose: onFailure,
    });
};
PasscodeModal.hide = (onDidHideCallback) => {
    Modal.hide(onDidHideCallback, { top: true });
};
export default PasscodeModal;
